import { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'

const Livebooks = lazy(() => import('@/deprecated/livebooks/index'))
const LivebooksCourse = lazy(() => import('@/deprecated/livebooks/Course'))
const LivebooksModule = lazy(() => import('@/deprecated/livebooks/Module'))
const LivebooksUnit = lazy(() => import('@/deprecated/livebooks/Unit'))
const Lesson = lazy(() => import('@/deprecated/livebooks/Lesson'))

const LivebookRouter = () => {
    return (
        <Routes>
            <Route index element={<Livebooks />} />
            <Route path=":course_slug" element={<LivebooksCourse />} />
            <Route
                path=":course_slug/:module_slug"
                element={<LivebooksModule />}
            />
            <Route
                path=":course_slug/:module_slug/:unit_slug"
                element={<LivebooksUnit />}
            />
            <Route
                path=":course_slug/:module_slug/:unit_slug/:lesson_id"
                element={<Lesson />}
            />
        </Routes>
    )
}

export default LivebookRouter
